export interface BarInitValues {
  value: number;
  bufferValue: number;
}

export const getBufferFillerWidth = ({
  value,
  bufferValue
}: BarInitValues): number => {
  const sum = value + bufferValue;

  return Math.min(sum, 100);
};

export const getProgressFillerWidth = ({
  value,
  bufferValue
}: BarInitValues): number => {
  const totalValue = getBufferFillerWidth({ value, bufferValue });

  if (totalValue <= 0) return 0;

  return (value / totalValue) * 100;
};
